// A simple XOR + Base64 obfuscation tool to prevent manual localStorage tampering
const SECRET_SALT = "accosync_admin_salt_key_123!";

export function encryptData(data: any): string {
  try {
    const jsonStr = JSON.stringify(data);
    let obfuscated = "";
    for (let i = 0; i < jsonStr.length; i++) {
      // Simple XOR with SECRET_SALT characters
      const charCode = jsonStr.charCodeAt(i) ^ SECRET_SALT.charCodeAt(i % SECRET_SALT.length);
      obfuscated += String.fromCharCode(charCode);
    }
    // Encode to base64 to make it safe for localStorage string format and unreadable
    return btoa(unescape(encodeURIComponent(obfuscated)));
  } catch (error) {
    console.error("Encryption error:", error);
    return "";
  }
}

export function decryptData(obfuscatedStr: string): any {
  if (!obfuscatedStr) return null;
  try {
    const rawStr = decodeURIComponent(escape(atob(obfuscatedStr)));
    let decrypted = "";
    for (let i = 0; i < rawStr.length; i++) {
      const charCode = rawStr.charCodeAt(i) ^ SECRET_SALT.charCodeAt(i % SECRET_SALT.length);
      decrypted += String.fromCharCode(charCode);
    }
    return JSON.parse(decrypted);
  } catch (error) {
    console.error("Decryption / Tampering detected:", error);
    return null;
  }
}
